<template>
  <section class="salemanage-manage__index column-index">
    <change-store></change-store>
    <column-info :column-list="columnList"></column-info>
  </section>
</template>

<script>
import ChangeStore from '../../components/ChangeStore'
import ColumnInfo from '../../components/ColumnInfo'

export default {
  components: {
    ChangeStore,
    ColumnInfo
  },
  data() {
    return {
      columnList: [
        {
          title: '客户接待',
          items: [
            {
              name: '线索',
              icon: 'clue',
              link: '/carregister/clue'
            },
            {
              name: '我的客户',
              icon: 'all-customer',
              link: '/carregister/salesnote'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="less">
  @import "../../../stylesheets/base/fn.less";
  @import "../../../stylesheets/modules/manage/columnList.less";
  .salemanage-manage__index {
    .column {
      @selectors: all-customer, clue;
      each(@selectors, {
        .@{value} {
          background: url('../../../stylesheets/images/index/@{value}.png') no-repeat center center / cover;
          background-size: contain;
        }
      })
    }
  }
</style>
